<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid || !formValid"
            [title]="(data.isEditMode ? 'Edit' : 'Add')+ ' Peer Connection'">

  <form #mapForm="ngForm" autocomplete="off" class="main-container">
    <div class="form-row">
      <mat-form-field class="fullWidth">
        <mat-label>Name</mat-label>
        <input matInput required [(ngModel)]="data.selectedItem.name" name="name">
      </mat-form-field>
    </div>

    <div class="form-row">
      <div class="form-column">
        <ac-input-container label="Type">
          <ac-select [acModel]="data.selectedItem.peerConnectionNodeType"
                     [searchable]="false"
                     alternativeName="data.selectedItem.peerConnectionNodeType"
                     (acModelChange)="data.selectedItem.peerConnectionNodeType = $event"
                     [items]="pConNodeTypesOptions">
          </ac-select>
        </ac-input-container>
      </div>

      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Weight</mat-label>
          <input matInput [(ngModel)]="data.selectedItem.weight" type="number" min="1"
                 max="100" name="weight" required>
        </mat-form-field>
      </div>
    </div>

    <ac-input-container label="Routing Interface">
      <ac-select [acModel]="data.selectedItem.riId"
                 [searchable]="false"
                 bindLabel="name"
                 bindValue="id"
                 alternativeName="peerConnection.riId"
                 (acModelChange)="data.selectedItem.riId = $event"
                 [items]="data.rIs"
                 [ngDisabled] = "data.isEditMode">
      </ac-select>
    </ac-input-container>

    <div class="form-row">
      <div class="form-column">
        <ac-input-container label="Operative State">
          <ac-select
                  [(acModel)]="data.selectedItem.operState"
                  [items]="pConsOperStateOptions"
                  [bindValue]="'value'"
                  [bindLabel]="'text'">
          </ac-select>
        </ac-input-container>
      </div>

      <div class="form-column">
        <ac-input-container label="Quality">
          <ac-select
                  [(acModel)]="data.selectedItem.result"
                  [items]="qualityOptions"
                  [bindValue]="'value'"
                  [bindLabel]="'text'">
          </ac-select>
        </ac-input-container>
      </div>
    </div>

    <div class="form-row">
      <div class="form-column">
        <mat-form-field class="fullWidth">
          <mat-label>Node</mat-label>
          <input disabled matInput [(ngModel)]="data.selectedItem.nodeName" name="armNodeName">
        </mat-form-field>
      </div>
      <div class="form-column-arrow">
        <img class="arrow" src="assets/images/general/leftToRightArrow.png">
      </div>
      <div class="form-column">
        <ac-input-container label="Voip Peer" [required]="true">
          <ac-select
                  [(acModel)]="data.selectedItem.voipPeerId"
                  [items]="data.voipPeers"
                  [multiple]="false"
                  [allowClear]="true"
                  [bindValue]="'value'"
                  [bindLabel]="'text'"
                  (acModelChange)="checkFormValid()">
          </ac-select>
        </ac-input-container>
      </div>
    </div>

    <mat-form-field *ngIf="data.selectedItem.topologyGroups && data.selectedItem.topologyGroups.length > 0" class="fullWidth">
      <mat-label>Resource Groups</mat-label>
      <div class="resource-groups-names">
        <mat-chip-list aria-label="Resource Groups" disabled>
          <mat-chip *ngFor="let group of data.selectedItem.topologyGroups"
                    [selectable]="false" class="resource-groups-names-chip" title="{{group.name}}">
            {{group.name}}
          </mat-chip>
        </mat-chip-list>
      </div>
    </mat-form-field>

    <div *ngIf="data.isEditMode">
      <divider title="Normalization Before Routing"></divider>

      <div class="form-row">
        <div class="form-column">
          <ac-input-container label="Source URI User">
            <ac-select
              [(acModel)]="data.selectedItem.srcNormalizationGroupId"
              [items]="data.attrManipulation"
              [multiple]="false"
              [allowClear]="true"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>
        </div>

        <div class="form-column">
          <ac-input-container label="Destination URI User">
            <ac-select
              [(acModel)]="data.selectedItem.destNormalizationGroupId"
              [items]="data.attrManipulation"
              [multiple]="false"
              [allowClear]="true"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>
        </div>
      </div>
    </div>

    <divider title="Advance Conditions"></divider>

    <div class="form-column">
      <ac-input-container label="CAC State">
        <ac-select
                [(acModel)]="data.selectedItem.cacState"
                [items]="cacStateOptions"
                [multiple]="false"
                [allowClear]="true"
                [bindValue]="'value'"
                [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>
    </div>
  </form>
</arm-dialog>
